import * as React from "react";
const SvgNextFill = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M9 4.92a2 2 0 0 1 1.147.362L17 10.08V6a1 1 0 1 1 2 0v12a1 1 0 1 1-2 0v-4.08l-6.853 4.798A2 2 0 0 1 7 17.079V6.921a2 2 0 0 1 2-2", clipRule: "evenodd" }));
export default SvgNextFill;
